import { faBuilding, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../css/processo.css';
import ReactComponent from './ReactComponent';
import TableRepresentante from './TableRepresentante';
import ExibirOcultarNome from './shared/ExibirOcultarNome';
import moment from 'moment';
import { SITUACAO_IMTIMACAO } from '@/dominio/SituacaoIntimacao';

class TableParte extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            corIconeProcuradoria: computed,
            corIconeDomicilioEletronico: computed,
            tituloDomicilioEletronico: computed
        });
    }

    get corIconeProcuradoria() {
        if (this.observableProps.parte.polo === 'POLO_ATIVO') {
            return 'rgb(56, 142, 60)';
        }

        if (this.observableProps.parte.polo === 'POLO_PASSIVO') {
            return 'rgb(183, 28, 28)';
        }

        return 'orange';
    }

    get corIconeDomicilioEletronico() {
        const parte = this.observableProps.parte;
        console.log('parte', parte);

        if (parte.intimacaoDomicilioEletronico?.dataIntimacao && parte.intimacaoDomicilioEletronico.dataCiencia) {
            return SITUACAO_IMTIMACAO.INTIMADO_E_CIENTE.cor;
        }
        if (parte.intimacaoDomicilioEletronico?.dataIntimacao) {
            return SITUACAO_IMTIMACAO.INTIMADO.cor;
        }
        return SITUACAO_IMTIMACAO.NAO_INTIMADO.cor;
    }

    get tituloDomicilioEletronico() {
        const dataIntimacao = this.observableProps.parte.intimacaoDomicilioEletronico?.dataIntimacao;

        if (!dataIntimacao) {
            return 'Parte com domicílio judicial eletrônico não intimada pela SE.';
        }
        const dataCiencia = this.observableProps.parte.intimacaoDomicilioEletronico?.dataCiencia;
        const cienciaAutomatica = this.observableProps.parte.intimacaoDomicilioEletronico?.cienciaAutomatica;

        let texto =
            'Parte intimada via domicílio judicial eletrônico em ' +
            moment(dataIntimacao, 'DD-MM-YYYY-HH-mm-ss').format('DD/MM/YYYY HH:mm:ss');
        const textoCienciaAutomatica = cienciaAutomatica ? 'automática ' : '';
        texto += dataCiencia
            ? ' com ciência em ' +
              textoCienciaAutomatica +
              moment(dataCiencia, 'DD-MM-YYYY-HH-mm-ss').format('DD/MM/YYYY HH:mm:ss') +
              '.'
            : '.';
        return texto;
    }

    render() {
        return (
            <div
                className="lista"
                style={{ margin: '5px' }}
            >
                {!!this.observableProps.parte.tipo && (
                    <Typography className="titulo">{this.observableProps.parte.tipo}</Typography>
                )}
                <div
                    style={{
                        fontSize:
                            this.observableProps.parte.procuradoria ||
                            this.observableProps.parte.codigoDomicilioEletronico
                                ? '14px'
                                : '16px'
                    }}
                    className={this.observableProps.classeAlinhamentoPartes ?? 'lista-align'}
                >
                    <ExibirOcultarNome
                        abreviarNome={this.observableProps.parte.nomeAbreviado}
                        estiloIcone={{ marginLeft: 1 }}
                        nome={this.observableProps.parte.nome}
                        nomeSocial={this.observableProps.parte.nomeSocial}
                        prefixoNome={this.observableProps.parte.prefixoNome}
                        registroComplementar={this.observableProps.parte.registroComplementar}
                    />
                    {this.observableProps.parte.procuradoria ? (
                        <Tooltip
                            placement="top"
                            title={<Typography>{this.observableProps.parte.procuradoria}</Typography>}
                        >
                            <FontAwesomeIcon
                                style={{
                                    cursor: 'default',
                                    width: '18px',
                                    height: '18px',
                                    marginRight: '5px',
                                    paddingLeft: '5px'
                                }}
                                color={this.corIconeProcuradoria}
                                icon={faBuilding}
                                id="corIconeProcuradoria"
                            />
                        </Tooltip>
                    ) : null}
                    {!!this.observableProps.parte.codigoDomicilioEletronico && (
                        <Tooltip
                            placement="top"
                            title={<Typography>{this.tituloDomicilioEletronico}</Typography>}
                        >
                            <FontAwesomeIcon
                                style={{
                                    cursor: 'default',
                                    width: '18px',
                                    height: '18px',
                                    marginRight: '5px',
                                    paddingLeft: '5px'
                                }}
                                color={this.corIconeDomicilioEletronico}
                                icon={faEnvelope}
                                id="domicilioEletronico"
                            />
                        </Tooltip>
                    )}
                </div>
                {this.renderRepresentantes()}
            </div>
        );
    }

    renderRepresentantes() {
        return (
            !this.observableProps.ocultarRepresentantes && (
                <div className="lista-align-left">
                    {this.observableProps.parte.representantes ? (
                        <TableRepresentante parteRepresentante={this.observableProps.parte.representantes} />
                    ) : (
                        <Typography sx={{ pl: '2em', color: 'darkorange', fontStyle: 'italic' }}>
                            SEM REPRESENTANTE
                        </Typography>
                    )}
                </div>
            )
        );
    }
}

export default inject('stores')(observer(TableParte));
